import { QueryClient } from 'react-query'

import { QUERY_CLIENT_DEFAULT_OPTIONS } from 'src/config'

const apiClient = new QueryClient({
  defaultOptions: { ...QUERY_CLIENT_DEFAULT_OPTIONS },
})

export default apiClient
